import React, { useState, useRef, useEffect } from "react";
import "./InfoTip.css";

/**
 * Small ⓘ button that toggles a popover message on click/tap.
 * @param {{ message: string }} props
 */
export function InfoTip({ message }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  return (
    <span ref={ref} className="infotip-wrapper">
      <button type="button" className="infotip-btn" onClick={() => setOpen((o) => !o)}>ⓘ</button>
      {open && <div className="infotip-popover">{message}</div>}
    </span>
  );
}
